<template>
    <div>
        <b-jumbotron>
            <h1>Set up your device in 3 easy steps.</h1>
        </b-jumbotron>
        <b-jumbotron>
            <p>Step 1</p>
            <h1>Install WireGuard</h1>
            <hr />
            <p>Download the WireGuard App for your device.</p>
            <AppList />
        </b-jumbotron>
        <b-jumbotron class="min-vh-100">
            <p>Step 2</p>
            <h1>Import Profiles</h1>
            <hr />
            <p>Install our server credentials onto your device.</p>
            <hr />
            <p>
                For <b>mobile devices</b>, scan the QR code with WireGuard. The
                tunnel name is displayed above the code.
            </p>
            <p>
                For <b>other devices</b>, download the file and import into
                WireGuard.
            </p>
            <b-alert show variant="info">
                Notice: Do not share the same config file across different
                devices! This will create a connection conflict that
                automatically disables your VPN. If you want to use more
                devices, go and add them in the dashboard afterwards. The QR
                file and the downloaded *.conf file is considered the same
                config.
            </b-alert>
            <Device />
        </b-jumbotron>
        <b-jumbotron>
            <p>Step 3</p>
            <h1>Enjoy your VPNla~</h1>
            <hr />
            <p v-if="user.plan.billingAmount != 0">
                Thank you for choosing VPNla! We really appreciate your support.
            </p>
            <div v-else>
                <h5>Reminder:</h5>
                <p class="mb-1">
                    You are currently using our free plan, which provides you
                    with 30 minutes of access and 100MBs of data.
                </p>
                <p>
                    If you think VPNla is right for you, please consider
                    <b-link to="/plans">subscribing to a paid plan</b-link>.
                </p>
            </div>
            <b-button-group size="lg">
                <b-button to="/plans">Change Plan</b-button>
                <b-button to="/dashboard" variant="primary">
                    Go back to dashboard
                </b-button>
            </b-button-group>
        </b-jumbotron>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    import AppList from '@/components/user/apps/list'
    import Device from '@/components/user/setup/device'

    export default {
        components: {
            AppList,
            Device
        },
        computed: mapState({
            user: state => state.user.user.user
        })
    }
</script>